export default "__VITE_ASSET__uhxjgZ9s__"